var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightMode = function SvgLightMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_3184)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.00029,
    r: 2.62002,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 6.01639,
    x2: 1.64319,
    y2: 6.01639,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.3568,
    y1: 6.01639,
    x2: 12,
    y2: 6.01639,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.00472,
    y1: 2.62268e-8,
    x2: 6.00472,
    y2: 1.64319,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.00469,
    y1: 10.3568,
    x2: 6.00469,
    y2: 12,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.74713,
    y1: 1.77505,
    x2: 2.90904,
    y2: 2.93696,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.06333,
    y1: 9.09099,
    x2: 10.2252,
    y2: 10.2529,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.2252,
    y1: 1.77058,
    x2: 9.06333,
    y2: 2.93249,
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.90981,
    y1: 9.0872,
    x2: 1.7479,
    y2: 10.2491,
    stroke: "currentColor",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_3184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
};
export default SvgLightMode;